<script lang="ts">
  import LegalFormFilters from '$lib/components/LegalFormFilters.svelte';
  import { scheduleCount } from '$lib/stores/guided';

  /**
   * Which legal forms to keep, and which to leave out.
   *
   * The same control the filter panel draws — see LegalFormFilters, which also
   * explains why keeping and dropping are two columns rather than one
   * three-state row. All this step adds is the running total: every tick
   * re-asks how large the selection now is, which is what makes the cost of
   * "no Einzelunternehmen" visible at the moment it is chosen rather than at
   * the end.
   *
   * The heading is suppressed because ScreenView has already named the step.
   */
</script>

<div class="mx-auto max-w-xl">
  <LegalFormFilters showTitle={false} onChange={scheduleCount} />
</div>
